import React, { ChangeEvent } from 'react';
import UploadIcon from '../../../assets/icons/UploadIcon';
import InfoIcon from '../../../assets/icons/InfoIcon';
import { generateUploadURL } from '../../../backend-services';
import { Button, SidebarDrawer } from '../../common';
import { CloseIcon, PDFIcon } from '../../../assets/icons';
import { toast } from 'react-hot-toast';
import RecordPaymentSuccess from './SuccessModal';
import { shortenFileName } from '../../../utils';
import { IInvoice, TransactionEvidenceEntity, TransactionType } from '../../../@types';
import ExpenseUploadSuccess from './ExpenseUploadSuccess';

interface UploadRecordPaymentProps {
  entity?: IInvoice;
  onRecordEntity: any;
  paymentType: TransactionType;
  closeModal: () => void;
}

const UploadTransactionEvidence: React.FC<UploadRecordPaymentProps> = ({ entity, onRecordEntity, paymentType,  closeModal, }) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [file, setFile] = React.useState<File | null>();
  const [error, setError] = React.useState<string>();
  const [isLoading, setIsLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const handleSelectFile = () => {
    inputRef.current?.click();
  };

  const handleUpload = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
      setError(undefined);
    }
  };

  const getPresignedURL = async (file: File): Promise<{ url: string; fields: any }> => {
    // Generate Upload URL
    const res = await generateUploadURL({
      customerId: paymentType === 'revenue' ? entity?.customer.id : undefined,
      transactionType: paymentType,
      entityId: paymentType === 'revenue' ? entity?.id : undefined,
      fileFormat: file.type.split('/')[1] as TransactionEvidenceEntity['fileFormat'],
    });
    const data = res.uploadURL;
    return { url: data.url, fields: data.fields };
  };

  const uploadToPresignedURL = async (url: string, fields: any, uploadedFile: File) => {
    const formData = new FormData();

    Object.keys(fields).forEach((key) => {
      formData.append(key, fields[key]);
    });

    formData.append('file', uploadedFile);

    const res = await fetch(url, {
      method: 'POST',
      body: formData,
    });

    if (!res.ok) {
      console.log(res);
      throw new Error(`${res.status} ${res.statusText}`);
    }
  };

  const handleRecordPayment = async () => {
    if (!file) {
      return setError('Please upload receipt.');
    }
    setError(undefined);

    try {
      setIsLoading(true);
      setIsLoading(true);
      // Get Upload URL
      const { url, fields } = await getPresignedURL(file);
      console.log('url', url);
      console.log('fields', fields);
      console.log('file', file);
      await uploadToPresignedURL(url, fields, file);

      setIsLoading(false);
      setSuccess(true);
    } catch (e: any) {
      console.log(e);
      setIsLoading(false);
      setError(e.message);
      toast.error('An error occured while uploading image: ' + e.message);
    }
  }
    const handleCloseModal = () => {
      // setSuccess(false);
      closeModal(); 
    };
  
    if (success) {
      if (paymentType === 'revenue') {
        return <RecordPaymentSuccess closeModal={handleCloseModal} />;
      } else if (paymentType === 'expenses') {
        return <ExpenseUploadSuccess closeModal={handleCloseModal} />;
      }
    }
  

  const buttonText = entity ? 'Upload Receipt' : 'Upload Expense';

  return (
    <>
      <div className="h-screen">
        <div className="mt-[43px] text-center leading-5">
          <p className="font-semibold">Upload payment receipt directly </p>
          <p>(It could be a jpg or png documentnt) </p>
        </div>
        {error ? <div className="text-center p-2 bg-red-300 text-red-700 font-medium mb-4">{error}</div> : null}

        <div className="flex justify-center mt-[13px]">
          <button
            onClick={handleSelectFile}
            className="flex items-center border border-[#828282] px-[13px] py-[8px] rounded-[4px] bg-[#EDF2F5] "
          >
            <p>Upload document</p>
            <div className="bg-[#D6DADD] w-[1px] h-full mx-[9px] "></div>
            <UploadIcon />
          </button>
          <input className="hidden" type="file" ref={inputRef} accept="jpg,jpeg,png" onChange={handleUpload} />
        </div>

        {file && (
          <div className="flex items-center justify-center text-lg mt-3">
            <PDFIcon />
            <span className="text-[#0500F9] mx-3 font-medium">{shortenFileName(file)}</span>
            <a href="#close" onClick={() => setFile(undefined)}>
              <CloseIcon color="red" />
            </a>
          </div>
        )}

        <div className="flex justify-center mt-[32px] ">
          <div className="w-[366px] h-[180px] bg-[#2F80ED] bg-opacity-[0.08] border border-[#2F80ED] rounded-[16px]  ">
            <div className="flex justify-center">
              <p className="text-[18px] flex gap-[16px] mt-[24px] items-center font-bold text-[#2E2E2E] ">
                <InfoIcon />
                How this works
              </p>
            </div>
            <div className="flex justify-center mt-[19px] leading-6  ">
              <p className="w-[312px] text-center text-[#5D6D73] ">
                Simply take a picture and upload expense, and <b>esemie</b> will extract the information and have it recorded in your
                payment history.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-center pt-[79px] pb-[60px]">
          <Button
            onClick={handleRecordPayment}
            variant="secondary"
            text={buttonText}
            isLoading={isLoading}
            disabled={isLoading}
            size="small"
          />
        </div>
      </div>
    </>
  );
};

export { UploadTransactionEvidence };
